import React from "react";
import ReactECharts from "echarts-for-react";

const LineChartComponent: React.FC = () => {
  const options = {
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: ["Poor", "Good"],
      bottom: 0,
    },
    xAxis: {
      type: "category",
      data: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        name: "Poor",
        type: "line",
        data: [10, 12, 15, 18, 20, 25, 30, 28, 26, 24, 22, 20],
        lineStyle: {
          color: "#f87171",
        },
        smooth: true,
      },
      {
        name: "Good",
        type: "line",
        data: [5, 7, 10, 13, 16, 20, 23, 21, 18, 16, 14, 12],
        lineStyle: {
          color: "#60a5fa",
        },
        smooth: true,
      },
    ],
  };

  return (
    <div className="bg-white  p-6 rounded-3xl w-full">
      <h3 className="text-base font-semibold text-gray-700 mb-4">
        Orders Analytics
      </h3>
      <ReactECharts option={options} style={{ height: 300, width: "100%" }} />
    </div>
  );
};

export default LineChartComponent;
